module.exports = __webpack_public_path__ + "img/icon-trivia.93b48170.png";